import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sonuc',
  templateUrl: './sonuc.component.html',
  styleUrls: ['./sonuc.component.css']
})
export class SonucComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
